/* eslint-disable import/no-extraneous-dependencies */
import { QueryClient as ReactQueryClient } from "@tanstack/react-query";

/**
 * Caching explanation.
 *
 * StaleTime:
 * The duration until a query transitions from fresh to stale.
 * As long as the query is fresh, data will always be read from
 * the cache only - no network request will happen! If the query
 * is stale (which per default is: 1 minute), you will still get
 * data from the cache, but a background refetch can happen under
 * certain conditions.
 *
 *
 * CacheTime:
 * The duration until inactive queries will be removed from the
 * cache. This defaults to 5 minutes. Queries transition to the
 * inactive state as soon as there are no observers registered,
 * so when all components which use that query have unmounted.
 *
 * DOCS:
 * https://tanstack.com/query/v4/docs/react/guides/caching
 * https://tkdodo.eu/blog/practical-react-query#the-defaults-explained
 */

const QueryClient = new ReactQueryClient({
	defaultOptions: {
		queries: {
			retry: 2, // Queries will retry 2 times by default
			staleTime: 2 * 60 * 1000, // 2 minutes
			gcTime: 5 * 60 * 1000, // 5 minutes
		},
		mutations: {
			retry: 0, // Mutations don't retry by default
			gcTime: 5 * 60 * 1000, // 5 minutes
		},
	},
});

export default QueryClient;
